import { useMemo } from "react"
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
} from "@mui/material"
import Text from "../Text"
import { theme } from "src/providers/ThemeProvider"

interface IButtonProps extends MuiButtonProps {
  loading?: boolean
  width?: string | number
  height?: string | number
}

const Button = ({
  children,
  loading = false,
  width = 140,
  height = 40,
  variant = "contained",
  sx,
  ...rest
}: IButtonProps) => {
  const renderContent = useMemo(() => {
    if (loading) return <CircularProgress size="22px" />
    return typeof children === "string" ? (
      <Text fontSize={20} fontWeight={700} lineHeight="31.65px">
        {children}
      </Text>
    ) : (
      children
    )
  }, [loading, children])

  return (
    <MuiButton
      variant={variant}
      {...rest}
      sx={{
        backgroundColor:
          variant === "text" ? "inherit" : theme.palette.success.main,
        textAlign: "center",
        padding: variant === "text" ? "0px" : "8px 0px",
        borderRadius: 16,
        width,
        height: variant === "text" ? "auto" : height,
        "&:hover": {
          backgroundColor:
            variant === "text" ? "inherit" : theme.palette.success.light,
        },
        textAlignLast: "center",
        textTransform: "capitalize",
        ...{ ...sx },
      }}
    >
      {renderContent}
    </MuiButton>
  )
}

export default Button
